import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
interface QuestionTooltipProps {
  tooltip: string;
}
export function QuestionTooltip({
  tooltip
}: QuestionTooltipProps) {
  return <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center h-4 w-4 rounded-full text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            aria-label="Help information"
          >
            <HelpCircle className="h-3 w-3" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="bg-popover border shadow-md text-foreground">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>;
}